import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=782bc35b&scoped=true&"
var script = {}
import style0 from "./Start.vue?vue&type=style&index=0&id=782bc35b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782bc35b",
  null
  
)

export default component.exports